/**
 * Created by BabylonS on 03/07/2016.
 */

global.$ = global.jQuery = $ = jQuery;

var PNotify    = require('pnotify');
window.PNotify = PNotify;

require("pnotify/dist/pnotify.css");
require("pnotify/dist/pnotify.buttons");
require("pnotify/dist/pnotify.buttons.css");
require("font-awesome/scss/font-awesome.scss");
require("malihu-custom-scrollbar-plugin/jquery.mCustomScrollbar.css");
require('../../lib/material-scrolltop-0.6.4/material-scrolltop.scss');

require('imports?define=>false!jquery-mousewheel/jquery.mousewheel')(jQuery);
require('malihu-custom-scrollbar-plugin');
require('../../lib/material-scrolltop-0.6.4/material-scrolltop');

require('jquery-ui/ui/disable-selection');
require('jquery-ui/ui/widgets/draggable')(jQuery);
require('jquery-ui/ui/widgets/droppable')(jQuery);
require('jquery-ui/ui/widgets/sortable')(jQuery);

/** @namespace PNotify.prototype.options */
Revolator = {
  init               : function () {

    Revolator.initFlashMessages();

    Revolator.initScrollAnimation();

    Revolator.initMenuActive();

    $('body').materialScrollTop();

  },
  initFlashMessages  : function () {
    PNotify.prototype.options.styling       = "bootstrap3";
    PNotify.prototype.options.delay           = 3000;
    PNotify.prototype.options.stack.firstpos1 = 150;
    PNotify.prototype.options.stack.firstpos2 = ($(window).width() / 2) - (Number(PNotify.prototype.options.width.replace(/\D/g, '')) / 2);
    $(window).resize(function () {
      PNotify.prototype.options.stack.firstpos2 = ($(window).width() / 2) - (Number(PNotify.prototype.options.width.replace(/\D/g, '')) / 2);
    });
  },
  initScrollAnimation: function () {
    $.fn.scrollView = function (f) {
      return this.each(function () {
        $('html, body').animate(
          {
            scrollTop: $(this).offset().top
          }
          , 300, function () {
            if (typeof f !== 'undefined') {
              return f();
            }
          });
      });
    };
  },
  initMenuActive     : function () {
    var pgurl = window.location.href.substr(window.location.href.lastIndexOf("/") + 1);
    $("#menu").find("ul li a").each(function () {
      var link = $(this);
      var href = link.attr("href");
      if (href === pgurl || href === window.location.pathname)
        link.parent().addClass("active");
    });
  }
};

Revolator.init();



//////////////////
// WEBPACK FOOTER
// ./revo_assets/admin/js/revolator.js
// module id = 411
// module chunks = 4